import Vue from "vue";
import Router from "vue-router";
import { getStorage, setStorage } from "../utils/common";

Vue.use(Router);
// 解决报错
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/bill", // v
    name: "bill",
    meta: {
      title: "开票申请"
    },
    component: () => import("@/pages/bill/bill")
  },
  {
    path: "/result", // v
    name: "result",
    meta: {
      title: "提交成功"
    },
    component: () => import("@/pages/bill/result")
  },
  {
    path: "/billUrl", // v
    name: "billUrl",
    meta: {
      title: "预览PDF"
    },
    component: () => import("@/pages/bill/billUrl")
  },
  {
    path: "/agreements", //v
    name: "agreements",
    meta: {
      title: "签署协议"
    },
    component: () => import("@/pages/agreements/index")
  },
  {
    path: "/agreement-info", //v
    name: "agreemen-info",
    meta: {
      title: "协议"
    },
    component: () => import("@/pages/agreements/info")
  },
  {
    path: "/user-agreement", // v
    name: "agreements",
    meta: {
      title: "用户协议"
    },
    component: () => import("@/pages/agreements/user")
  },
  {
    path: "/secret-agreement", //v
    name: "agreements",
    meta: {
      title: "隐私协议"
    },
    component: () => import("@/pages/agreements/secret")
  },
  {
    path: "/app-pay",
    name: "app-pay",
    meta: {
      title: "支付"
    },
    component: () => import("@/pages/pay/index")
  },
  {
    path: "/nameCheck", // v
    name: "nameCheck",
    meta: {
      title: "实名认证"
    },
    component: () => import("@/pages/check/nameCheck")
  },
  {
    path: "/riskCheck", // v
    name: "riskCheck",
    meta: {
      title: "风险测评"
    },
    component: () => import("@/pages/check/riskCheck")
  },
  {
    path: "/riskResult", // v
    name: "riskResult",
    meta: {
      title: "风险测评结果"
    },
    component: () => import("@/pages/check/riskResult")
  },
  {
    path: "/scoring", // v
    name: "scoring",
    meta: {
      title: "打分",
      isLogin: true,
    },
    component: () => import("@/pages/scoring/index")
  },
  {
    path: "/scoringResult", // v
    name: "scoringResult",
    meta: {
      title: "打分结果",
      isLogin: true,
    },
    component: () => import("@/pages/scoring/result")
  },
  {
    path: "/user-agreement-pg", //v
    name: "user-agreement-pg",
    meta: {
      title: "用户协议"
    },
    component: () => import("@/pages/agreements/user-pg")
  },
  {
    path: "/user-agreement-pg-xcx", //v
    name: "user-agreement-pg-xcx",
    meta: {
      title: "用户协议"
    },
    component: () => import("@/pages/agreements/user-pg-xcx")
  },
  {
    path: "/secret-agreement-pg", //v
    name: "secret-agreement-pg",
    meta: {
      title: "隐私协议"
    },
    component: () => import("@/pages/agreements/secret-pg")
  },
  {
    path: "/secret-agreement-pg-xcx", // v
    name: "secret-agreement-pg-xcx",
    meta: {
      title: "隐私协议"
    },
    component: () => import("@/pages/agreements/secret-pg-xcx")
  },
  {
    path: "/back-agreement-pg", // v
    name: "back-agreement-pg",
    meta: {
      title: "电子回访协议"
    },
    component: () => import("@/pages/agreements/back-pg")
  },
  {
    path: "/back-agreement-pg-success", // v
    name: "back-agreement-pg-success",
    meta: {
      title: "电子回访协议结果"
    },
    component: () => import("@/pages/agreements/back-pg-result")
  },
  {
    path: "/service-pg", //v
    name: "service-pg",
    meta: {
      title: "服务协议"
    },
    component: () => import("@/pages/agreements/service-pg")
  },
  {
    path: "/serviceTermination",
    name: "serviceTermination",
    meta: {
      title: "服务协议"
    },
    component: () => import("@/pages/agreements/serviceTermination")
  },

  {
    path: "/v2/service-pg", //v
    name: "service-pg",
    meta: {
      title: "服务协议"
    },
    component: () => import("@/pages/agreements/service-pg")
  },
  {
    path: "/contractPdf", //v
    name: "contractPdf",
    meta: {
      title: "订单合同"
    },
    component: () => import("@/pages/agreements/contractPdf")
  },
  {
    path: "/v2/risk", // v
    name: "risk",
    meta: {
      title: "风险揭示书"
    },
    component: () => import("@/pages/agreements/v2/risk")
  },
  {
    path: "/v2/suitable", //v
    name: "suitable",
    meta: {
      title: "适当性评估确认书"
    },
    component: () => import("@/pages/agreements/v2/suitable")
  },
  {
    path: "/news", //v
    name: "news",
    meta: {
      title: "无为股道-投资教练，专业陪伴"
    },
    component: () => import("@/pages/news/index")
  },
  {
    path: "/publicize", //v
    name: "publicize",
    meta: {
      title: "产品详情"
    },
    component: () => import("@/pages/publicize/index")
  },
  {
    path: "/fightIntro", //v
    name: "fightIntro",
    meta: {
      title: "战法介绍"
    },
    component: () => import("@/pages/fightIntro/index")
  },
  {
    path: "/ideaShare",
    name: "ideaShare",
    meta: {
      title: "动态分享"
    },
    component: () => import("@/pages/ideaShare/index")
  },
  {
    path: "/download",
    name: "download",
    meta: {
      title: "APP下载"
    },
    component: () => import("@/pages/downloadApp/index")
  },
  {
    path: "/refund-agreement",
    name: "refund-agreement",
    meta: {
      title: "退款协议",
      isLogin: true
    },
    component: () => import("@/pages/agreements/refund")
  },
  {
    path: "/refund-pdf", // 用来生成退款协议的pdf
    name: "refund-pdf",
    meta: {
      title: "退款协议",
      isLogin: true
    },
    component: () => import("@/pages/agreements/refundPdf")
  },
  {
    path: "/phoneLogin",
    name: "phoneLogin",
    meta: {
      title: "登录",
      keepAlive: true
    },
    component: () => import("@/pages/login/index")
  },
  {
    path: "/refundOk",
    name: "refundOk",
    meta: {
      title: "结果页",
      isLogin: true
    },
    component: () => import("@/pages/agreements/refundOk")
  },
  {
    path: "/scoringTable",
    name: "scoringTable",
    meta: {
      title: "打分表",
    },
    component: () => import("@/pages/scoring/scoringTable")
  },
  {
    path: "/weChatLogin",
    name: "weChatLogin",
    meta: {
      title: "微信登录",
    },
    component: () => import("@/pages/weChatLogin/index")
  },
  {
    path: "/matchEnroll",
    name: "matchEnroll",
    meta: {
      title: "模拟大赛",
    },
    component: () => import("@/pages/enroll/index")
  },
   {
    path: '/qwPdf', //单聊消息下载
		name: 'qwPdf',
		meta: {
			title: '企微下载'
		},
		component: () => import('@/pages/qwPdf')
  },
  {
    path: '/groupPdf',
		name: 'groupPdf',
		meta: {
			title: '群消息下载'
		},
		component: () => import('@/pages/qwPdf/group')
  },
  {
    path: '/socialPdf', //单聊消息下载
		name: 'socialPdf',
		meta: {
			title: '圈子消息下载'
		},
		component: () => import('@/pages/socialPdf/social')
  },
  { path: "*", component: () => import("@/pages/404") }
];

const router = new Router({
  mode: "history", //history设置
  routes,
  base: location.pathname.includes("login") ? null : "/commonjs"
  // base: '/commonjs'
});

router.beforeEach((to, from, next) => {
  // 路由守卫
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.isLogin) {
    // 需要登录
    const { token } = to.query;
    if (token) {
      setStorage("token", token);
    }
    if (!getStorage("token")) {
      next({
        path: "/phoneLogin",
        query: {
          url: "https://" + location.host + "/commonjs" + to.fullPath
        }
      });
      return;
    }
    next();
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
